import { ShowContext } from 'ui-builder';
import { usePlansService } from 'nekst-api';
import React from 'react';

export function PlanContext(props: {
  id: number,
  children: React.ReactNode,
}) {
  const plansService = usePlansService();

  return (
    <ShowContext
      getDataFunc={async () => plansService.getById(props.id)}
    >
      {props.children}
    </ShowContext>
  )
}
